(function() {

	var siteNavigation = document.querySelector(".site-navigation-holder");
	var body = document.querySelector('body');

	if(!siteNavigation || !siteNavigation.classList.contains('align-navigation-for-subpage')) {
		return;
	}

	var scrollPosition = false;

	window.addEventListener('scroll', onScroll);
	window.addEventListener('resize', onResize);

	function onScroll() {
		requestAnimationFrame(function() {
			var newScrollPosition = window.pageYOffset;

			if(scrollPosition === newScrollPosition) {
				return;
			}
			scrollPosition = newScrollPosition;

			updateVisibilityOfBackToHomepageButton();
		});
	}

	function onResize() {
		requestAnimationFrame(function() {
			updateVisibilityOfBackToHomepageButton();
		});
	}

	function updateVisibilityOfBackToHomepageButton() {
		var bottomOfPage = (window.innerHeight + window.pageYOffset) >= document.body.scrollHeight - 200;
		if (!bottomOfPage && body.classList.contains('hide-language-navigation')) {
			body.classList.remove('hide-language-navigation');
		} else if (!bottomOfPage) {
			return;
		}
		else if (bottomOfPage && body.classList.contains('hide-language-navigation')) {
			return;
		} else if (bottomOfPage) {
			body.classList.add('hide-language-navigation');
		}
	}

	updateVisibilityOfBackToHomepageButton();

}());
